module.exports = __webpack_public_path__ + "static/4-039883ffa6dbed51e536e6ab09fa56b1.jpg";